import * as React from "react";
import { useFieldArray, useWatch, Control } from "react-hook-form";
import {
  Grid,
  ActionIcon,
  Text,
  Flex,
  useMantineTheme,
  Stack,
  Title,
  Group,
} from "@mantine/core";
import { IconPlus } from "@tabler/icons-react";
import { CSelect } from "@supportinitiative/react-hook-form-mantine";

import { UseCaseCVMContext } from "../UseCaseCVMContext";
import { IconTrash } from "@tabler/icons-react";
import ReconDatasetCVM from "./ReconDatasetCVM";

function DatasetsCVM({
  name,
  control,
}: {
  name: `definition.recons.${number}.definition`;
  control: Control<any>;
}) {
  const { state: useCaseFormState } = React.useContext(UseCaseCVMContext);
  const theme = useMantineTheme();

  const datasetsArray = useFieldArray({
    control,
    name: `${name}.datasets`,
    keyName: "key",
  });

  return (
    <Stack>
      <Stack gap="0">
        <Group align="center">
          <Flex>
            <Title
              m={0}
              order={5}
              style={{
                padding: "0px 5px",
                backgroundColor: "#16A596",
                color: "#fff",
              }}
            >
              Datasets
            </Title>
          </Flex>
          <ActionIcon
            size="sm"
            variant="white"
            color="gray"
            onClick={() => {
              datasetsArray.append({
                id: "",
                datasetId: "",
                name: "",
                description: "",
                columns: [],
                additionalColumns: [],
                resetMatchOnChangeOf: [],
                access: "",
              });
            }}
            style={{
              display:
                useCaseFormState.currentAction.toUpperCase() === "VIEW"
                  ? "none"
                  : "",
            }}
            disabled={useCaseFormState.actionOptions.disableAll}
          >
            <IconPlus />
          </ActionIcon>
        </Group>
      </Stack>

      <Grid align="stretch" gutter={"xs"} mb="xs">
        {datasetsArray.fields.map((field, index) => {
          return (
            <Grid.Col span={2} pt="0" key={field.key}>
              <Flex align="end">
                <ReconDatasetCVM
                  name={`${name}.datasets.${index}`}
                  control={control}
                />
                {!useCaseFormState.actionOptions.disableAll && (
                  <ActionIcon
                    size="sm"
                    variant="white"
                    color="gray"
                    ml="xs"
                    onClick={() => {
                      datasetsArray.remove(index);
                    }}
                    disabled={useCaseFormState.actionOptions.disableAll}
                  >
                    <IconTrash />
                  </ActionIcon>
                )}
              </Flex>
            </Grid.Col>
          );
        })}
      </Grid>
    </Stack>
  );
}

export default DatasetsCVM;
